import React, { useContext, useState, useEffect, createContext } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "@lib/firebase";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getIdToken = async () => {
    if (!user) {
      throw new Error("No user is signed in.");
    }
    return await user.getIdToken();
  };

  const logout = () => signOut(auth);

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={{ user, logout, loading, getIdToken }}>
      {children}
    </AuthContext.Provider>
  );
};